import { Configuration, LogLevel } from '@azure/msal-browser';

import { getRuntimeConfig } from './runtime-config';

export const getMsalConfig = (): Configuration => {
  const runtimeConfig = getRuntimeConfig();

  return {
    auth: {
      clientId: runtimeConfig.azureClientId ?? '',
      authority: `https://login.microsoftonline.com/${runtimeConfig.azureTenantId ?? ''}`,
      redirectUri: runtimeConfig.azureRedirectUri,
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;

          switch (level) {
            case LogLevel.Error:
              console.error(message);
              break;
            case LogLevel.Warning:
              console.warn(message);
              break;
          }
        },
      },
    },
  };
};
